import cookie from "./cookie";
export const indexConstant = Object.assign({},
    cookie,
);
export * from './paGinate';